import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const salesStatusListWidget: DashboardWidgetConfiguration = {
  widgetId: "sales.status-list",
  name: "Orders by status list",
  description: "A compact RQL list without search or pagination.",
  apps: [
    "home",
    "sales",
    "crm",
    "finance",
    "invoicing",
    "point-of-sale",
    "subscriptions",
  ],
  template: "list",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "sales.analysis",
      ...period(30),
      select: [
        {
          type: "field",
          field: "status",
          as: "status",
        },
        {
          type: "aggregate",
          function: "count_distinct",
          field: "order_id",
          as: "orders",
        },
      ],
      group_by: [
        {
          field: "status",
        },
      ],
      order_by: [
        {
          ref: "orders",
          direction: "desc",
        },
      ],
      limit: 6,
    },
  },
  inputs: {
    title: "Orders by status",
    columns: [
      {
        key: "status",
        label: "Status",
      },
      {
        key: "orders",
        label: "Orders",
        align: "end",
        format: "number",
      },
    ],
    emptyText: "No sales orders in this period.",
  },
  dummyData: {
    rows: [
      {
        status: "Confirmed",
        orders: 42,
      },
      {
        status: "Sent",
        orders: 21,
      },
      {
        status: "Draft",
        orders: 9,
      },
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 4,
    defaultHeight: 4,
  },
};
